import React from 'react';

import RootStack from '../../../../RootStack';

import SceneFormIllustrationShowSceneCommandEditIllustrationSearchForm from '../../../../../containers/scene_form/illustration_show_scene_command/edit/illustration_search_form/Index';

const Stack = () => {
  return (
    <RootStack.Navigator
      screenOptions={{
        animationEnabled: true,
        headerShown: false,
      }}
      initialRouteName="SceneFormIllustrationShowSceneCommandEditIllustrationSearchForm">
      <RootStack.Screen
        name="SceneFormIllustrationShowSceneCommandEditIllustrationSearchForm"
        component={
          SceneFormIllustrationShowSceneCommandEditIllustrationSearchForm
        }
        options={{title: 'アイテム検索条件'}}
      />
    </RootStack.Navigator>
  );
};

export default Stack;
